<script>
import { defineCustomElement } from "vue";
import textEditor from "../components/textEditor.ce.vue";
import textEditor2 from "../components/textEditor2.ce.vue";
import FontAwesomeIcon from "../plugins/font-awesome.vue";

import { createApp, h } from "vue";
import wrapper from "vue3-webcomponent-wrapper";

const TextEditor = defineCustomElement(textEditor);
const TextEditor2 = defineCustomElement(textEditor2);
const FontAwesome = wrapper(FontAwesomeIcon, createApp, h);

customElements.define("text-editor", TextEditor);
customElements.define("text-editor2", TextEditor2);
customElements.define("font-awesome-icon", FontAwesome);

export default {};
</script>
